module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/over-image-stats/over-image-stats.component.scss
// module id = ./src/app/modules/common-module/components/over-image-stats/over-image-stats.component.scss
// module chunks = 9